import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { readUserSession } from '../utils/readUserSession';
import { setAuthentication } from '../ducks/authDuck';
import { getFaasApiUrl } from '../selectors/getBaseUrlSelectors';
import { getMockLogin } from '../selectors/getMockLogin';

const useCheckLoggedInStatusHook = () => {
  const revalidatedSessionRef = useRef(false);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const faasApiUrl = useSelector(getFaasApiUrl);
  const isMockLoggedIn = useSelector(getMockLogin);
  const dispatch = useDispatch();

  // temporary, todo: remove whe Horizons go live in all markets
  // This was added to handle the case where
  //  a user navigates from an external domain (iseatz Z2) using the browser back button on Safari
  const revalidateUserSession = useCallback(async () => {
    if (global.BROWSER && !isLoggedIn && !isMockLoggedIn && !revalidatedSessionRef.current) {
      const isSessionValid = await readUserSession(faasApiUrl);
      revalidatedSessionRef.current = true;

      if (isSessionValid) {
        dispatch(setAuthentication(true));
        window.location.reload();
      }
    }
  }, [dispatch, faasApiUrl, isLoggedIn, isMockLoggedIn]);

  useEffect(() => {
    revalidateUserSession();
  }, [revalidateUserSession]);
};

export default useCheckLoggedInStatusHook;
